import { A } from 'AtomicComponents'


const Hyperlink = A;

export default Hyperlink



// WEBPACK FOOTER //
// ./src/components/hyperlink/index.jsx